import { render, staticRenderFns } from "./PermissionList.vue?vue&type=template&id=603c49ae"
import script from "./PermissionList.js?vue&type=script&lang=js&external"
export * from "./PermissionList.js?vue&type=script&lang=js&external"
import style0 from "./PermissionList.vue?vue&type=style&index=0&id=603c49ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports